import type { Action, PayloadAction } from '@reduxjs/toolkit';


export type QualificationAttachment = {
  id: number;
  file_id: number;
  file_name: string;
  file_url: string;
  file_content: string;
  file_size: number;
  update_datetime: string;
  update_user_name: string;
}
export type LocalQualificationAttachment = {
  data?: File
} & QualificationAttachment;

export type QualificationDefinition = {
  id: number;
  isNational: boolean;
  title: string;
}

export type WorkTypeDefinition = {
    work_type_id : number,
    work_type_name: string
}
export type AffilicationTypeDefinition = {
  notification_officer_affiliation_type_id : number,
  notification_officer_affiliation_type_name : string
}

export type QualificationAssignStatus = "" | "PAST" | "CURRENT" | "FUTURE";
export const isCurrent = (s : QualificationAssignStatus) : boolean => {
  return s === "CURRENT";
}
export const isFuture = (s: QualificationAssignStatus) : boolean => {
  return s === "FUTURE";
}
export const isPast = (s: QualificationAssignStatus) : boolean => {
  return s === "PAST";
}


export type Qualification = {
  id: number;
  isBuiltIn: boolean;
  qualificationId: number;
  qualificationName: string;
  assignmentType: number;
  assignmentTypeName? : string | null;
  assignmentStatus: QualificationAssignStatus;
  representativeType: number;
  representativeTypeName?: string | null;
  qualificationLevel: string;
  registeredUserId: number | null;
  registeredName: string;
  appointmentDate: string;
  dismissalDate: string;
  affiliateCompanyId: number;
  affiliateCompanyName: string;
  comment: string;
  attachments: QualificationAttachment[];
}

type SpecialQualificationBase = {
  id: number;
  qualificationName: string;
  description: string;
}
/**
 * 個別資格
 */
export type SpecialQualification = {
  isDeleted: boolean;
} & SpecialQualificationBase;

export type SpecialQualificationSubmitData = {
  id: number | null,
  qualificationName: string;
  description: string;
  isDeleted: boolean;
};

export type APISetSpecialQualificationRequest = {
  individual_qualification_name: string;
  remarks: string;
};

export type APIUseSpecialQualificationParam = {
  individual_qualification_id: number;
  property_id: number
}

export type APIUseSpecialQualificationRequest = {
  list: APIUseSpecialQualificationParam[];
}

export type SpecialQualificationReference = {
  individual_qualification_id: number;
  individual_qualification_name: string;
  remarks: string;
  is_allocated: boolean;
}

export type APIPropertyQualificationMap = {
  qualification_id: number;
  qualification_name: string;
  remarks: string;
  is_allocated: boolean;
}
export type APIPropertyQualificationMapResponse = {
  result: {
    list: APIPropertyQualificationMap[];
  }
}


// const representativeMap : { [id: number]: string } = {
//     1:"自社社員",
//     2:"オーナー側の社員",
//     3:"外注など"
// };
// const assignmentTypesMap: { [id: number]: string } = {
//     1:"選任",
//     2:"兼任"
// }


// export const getRepresentatives = () =>
// {
//     const pair = Object.entries(representativeMap);
//     return pair.map((p) => { return {value: Number(p[0]), title: p[1] } });
// }

// export const getAssignmentTypes = () =>
// {
//     const pair = Object.entries(assignmentTypesMap);
//     return pair.map((p) => { return {value: Number(p[0]), title: p[1] } });
// }


export type QualificationState = {
  refresh: Record<string, never>;
  isLoading: boolean;
  isHistoryLoading: boolean;
  isDetailLoading: boolean,
  isSubmitting: boolean;
  isNavigating: boolean;
  isNavigatingTo: number | null;
  qualifications: Qualification[],
  definitions: QualificationDefinition[],
  workTypes: WorkTypeDefinition[],
  affiliationTypes: AffilicationTypeDefinition[],
  qualificationDetail: Qualification,
  histories: Qualification[],
  specialDefinitions: SpecialQualification[];
  specialReferences: SpecialQualificationReference[];
};


/**
 * Definitions of ActionTypes
 */
export enum QualificationActionTypes {
  INIT = 'qualifications/init',
  REFRESH = 'qualifications/refresh',
  LOADING = 'qualifications/isLoading',
  HISTORYLOADING = 'qualifications/history/isLoading',
  DETAILLOADING = 'qualifications/detail/isLoading',
  NAVIGATING = 'qualifications/isNavigating',
  NAVIGATINGTO = 'qualifications/isNavigatingTo',
  SUBMITTING = 'qualifications/isSubmitting',
  SET_SELECT_MST_WORK_TYPES = 'qualifications/set/selectWorktypesListInfo',
  SET_SELECT_MST_AFFILIATION_TYPES = 'qualifications/set/selectAffiliationsListInfo',
  SET_SELECT_MST_NATIONAL_QUALIFICATIONS = 'qualifications/set/selectNationalQualificationListInfo',
  SET_SELECT_QUALIFICATIONS = 'qualifications/set/selectQualificationListInfo',
  SET_SELECT_QUALIFICATION_DETAIL= 'qualifications/set/selectQualificationInfo',
  SET_SELECT_QUALIFICATION_HISTORY = 'qualifications/set/selectHistoryListInfo',
  SET_SELECT_SPECIAL_DEFINITIONS_LIST = 'qualifications/set/selectSpecQcaListInfo',
  SET_SELECT_SPECIAL_QUALIFICATION_USED_INPROPERTY = 'qualifications/set/selectSpecialQcaUsedInProperty',
}

export type QualificationAction =
  | Action<QualificationActionTypes.INIT>
  | Action<QualificationActionTypes.REFRESH>
  | PayloadAction<boolean, QualificationActionTypes.LOADING>
  | PayloadAction<boolean, QualificationActionTypes.HISTORYLOADING>
  | PayloadAction<boolean, QualificationActionTypes.DETAILLOADING>
  | PayloadAction<boolean, QualificationActionTypes.NAVIGATING>
  | PayloadAction<number, QualificationActionTypes.NAVIGATINGTO>
  | PayloadAction<boolean, QualificationActionTypes.SUBMITTING>
  | PayloadAction<AffilicationTypeDefinition[], QualificationActionTypes.SET_SELECT_MST_AFFILIATION_TYPES>
  | PayloadAction<WorkTypeDefinition[], QualificationActionTypes.SET_SELECT_MST_WORK_TYPES>
  | PayloadAction<QualificationDefinition[], QualificationActionTypes.SET_SELECT_MST_NATIONAL_QUALIFICATIONS>
  | PayloadAction<Qualification[], QualificationActionTypes.SET_SELECT_QUALIFICATIONS>
  | PayloadAction<Qualification, QualificationActionTypes.SET_SELECT_QUALIFICATION_DETAIL>
  | PayloadAction<SpecialQualification[], QualificationActionTypes.SET_SELECT_SPECIAL_DEFINITIONS_LIST>
  | PayloadAction<Qualification[], QualificationActionTypes.SET_SELECT_QUALIFICATION_HISTORY>
  | PayloadAction<SpecialQualificationReference[], QualificationActionTypes.SET_SELECT_SPECIAL_QUALIFICATION_USED_INPROPERTY>;

export type APICreateQualifications = {
  readonly id: number;
  readonly type: string;
  readonly work_type_id: number;
  readonly registered_user_id: number;
  readonly notification_officer_affiliation_type_id: number;
  readonly appointment_date: string;
  readonly dismissal_date: string | null;
  readonly remarks: string;
  readonly property_id: number;
  readonly qualification_id: number;
  readonly qualification_type: number;
  file_list: APIQualificationAttachment[];
}

export type APIQualifications = {
  readonly id: number;
  readonly property_id: number;
  readonly property_name: string;
  readonly qualification_type: number;
  readonly qualification_id: number;
  readonly qualification_name: string;
  readonly type: string;
  readonly notification_qualification_id: number;
  readonly work_type_id: number;
  readonly work_type_name: string;
  readonly notification_status_id: number;
  readonly notification_status_name: string;
  readonly registered_user_id: number;
  readonly registered_user_name: string;
  readonly affiliate_company_id: number;
  readonly affiliate_company_name: string;
  readonly notification_officer_affiliation_type_id: number;
  readonly notification_officer_affiliation_type_name: string;
  readonly appointment_date: string;
  readonly dismissal_date: string;
  readonly remarks: string;
  file_list: APIQualificationAttachment[];
  is_deleted: boolean;
}
export type APIQualificationDefinition = {
  id: number;
  name: string;
  is_national: boolean;
  order: number
}
export type APIQualificationsResponse = {
  result: {
    list: APIQualifications[];
    definitions: APIQualificationDefinition[];
    affiliation_types: AffilicationTypeDefinition[];
    work_types: WorkTypeDefinition[];
  }
}
export type APIQualificationDetailResponse = {
  result: APIQualifications
}
export type APIQualificationHistoryResponse = {
  result: APIQualifications[]
}

export type APIQualificationAttachment = {
  id: number;
  file_id: number;
  file_name: string;
  file_url: string;
  update_datetime: string;
  update_user_name: string;
  file_size: number;
}

export type APISpecQualifications = {
  readonly individual_qualification_id: number;
  readonly individual_qualification_name : string;
  readonly remarks: string;
}
export type APISpecQualificationsResponse = {
  result: {
    list: APISpecQualifications[];
  }
}

export type APIQualificationHistory = {
  readonly no: number;
  readonly assignment_type_name: string | null;
  readonly declaration_status_name: string | null;
  readonly representative_type_name: string | null;
  readonly qualification_level: string | null;
  readonly registered_name: string | null;
  readonly assignment_date: string | null;
  readonly dismissal_date: string | null;
  readonly affilicate_company_name: string | null;
  readonly comment: string | null;
  readonly attachments: {
    file_id?: number;
    file_name?: string | null;
    title?: string;
    url?: string;
    is_delete_file?: boolean;
  }[]
}

export const defaultValue : Qualification = {
  id: 0,
  isBuiltIn: false,
  qualificationId: 0,
  qualificationName: "",
  assignmentType: 0,
  assignmentTypeName : "",
  assignmentStatus: "",
  representativeType: 0,
  representativeTypeName: "",
  qualificationLevel: "",
  registeredUserId: 0,
  registeredName: "",
  appointmentDate: "",
  dismissalDate: "",
  affiliateCompanyId: 0,
  affiliateCompanyName: "",
  comment: "",
  attachments: []
}
